import { render, staticRenderFns } from "./QuotationApprovalMail.vue?vue&type=template&id=828032b2"
import script from "./QuotationApprovalMail.vue?vue&type=script&lang=js"
export * from "./QuotationApprovalMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports